<template>
    <div class="campaign-option campaign-adset-location">
        <div class="campaign-option--title">
            Select States
            <info-tooltip text="Select the states where your ad set will appear."></info-tooltip>
        </div>

        <base-state-selector
            v-model="locationsForSelect"
            ref="state-select"
            :states-list="statesList"
            placeholder="Select States">
        </base-state-selector>

        <label v-show="showErrors && !validation.locations" class="error">The State field is required.</label>
    </div>
</template>

<script>
    import BaseStateSelector from '../shared/base-state-selector.vue'

    export default {
        components: { BaseStateSelector },

        props: {
            value: Array,
            locationsList: Array,
            showErrors: { type: Boolean, default: false }
        },

        data() {
            return {
                locationsForParent: this.value,
                locationsForSelect: this.value
            }
        },

        watch: {
            value(value) {
                this.locationsForParent = value;
            },

            locationsForSelect(locations) {
                this.locationsForSelect = locations;
                this.locationsForParent = locations;

                this.$emit('input', this.locationsForParent);
                this.$emit('validation', 'locations', this.isValid);
            }
        },

        mounted() {
            this.$emit('validation', 'locations', this.isValid);
        },

        computed: {
            statesList() {
                return Array.from(_(this.locationsList).filter(location => {
                    return (location.id !== 'PR' && location.id !== 'US');
                }));
            },

            validation() {
                return {
                    locations: this.locationsForParent != null ? (this.locationsForParent.length > 0) : false
                };
            },

            isValid: function () {
                return this.validation.locations;
            },
        },

        methods: {
            reset() {
                this.$refs['state-select'].reset()
            },
            setToAllStates() {
                this.$refs['state-select'].selectAll()
            },
        }
    }
</script>
